import React, { useState } from 'react';
import './Gallery.css';
import Gallery_image_1 from '../Gallery/ImageGallery/IMG_6979.JPG';
import Gallery_image_2 from '../Gallery/IMG_3005.JPG';
import Gallery_image_3 from '../Gallery/ImageGallery/IMG_1365 (FILEminimizer).JPG';
import Gallery_image_4 from '../Gallery/ImageGallery/IMG_1610 (FILEminimizer).JPG';
import Gallery_image_5 from '../Gallery/ImageGallery/DSC_0114.JPG';
import Gallery_image_6 from '../Gallery/ImageGallery/IMG_6969.JPG';
import Gallery_image_7 from '../Gallery/ImageGallery/IMG_1646 (FILEminimizer).JPG';
import Gallery_image_8 from '../Gallery/ImageGallery/IMG_1621 (FILEminimizer).JPG';
import Gallery_image_9 from '../Gallery/ImageGallery/IMG_7304.JPG';
import Gallery_image_10 from './webimages/DSC_9022.JPG'
import Gallery_image_11 from './blood donation camp/IMG_7393.JPG';
import Gallery_image_12 from './Cad/WhatsApp Image 2025-04-23 at 12.14.12_bb3bf292.jpg';
import Gallery_image_13 from './Cad/WhatsApp Image 2025-04-23 at 12.14.13_08c68e4a.jpg';
import Gallery_image_14 from './Cad/WhatsApp Image 2025-04-23 at 12.14.18_aa3e7043.jpg';
import Gallery_image_15 from './placement/WhatsApp Image 2025-04-30 at 10.54.20_bf1ba9ff.jpg';
import Gallery_image_16 from './placement/WhatsApp Image 2025-04-30 at 10.54.21_d7da9c42.jpg';
import Gallery_image_17 from './ptm/WhatsApp Image 2025-04-30 at 11.06.00_a246eabe.jpg';
import Gallery_image_18 from './ptm/WhatsApp Image 2025-04-30 at 11.06.02_7af4df41.jpg';
import Gallery_image_19 from './ptm/WhatsApp Image 2025-04-30 at 11.06.22_8a41b652.jpg';
import Gallery_image_20 from './ptm/WhatsApp Image 2025-04-30 at 11.06.05_f54490a3.jpg';
import Gallery_image_21 from "./industrial visit/WhatsApp Image 2025-04-18 at 15.06.43_ca3a242e.jpg"
import Gallery_image_22 from "./industrial visit/WhatsApp Image 2025-04-18 at 15.06.43_6ae81621.jpg"




const Gallery = () => {
  const images = [
   
     Gallery_image_1, Gallery_image_2, Gallery_image_3, Gallery_image_4,,Gallery_image_5, Gallery_image_6, Gallery_image_7 , Gallery_image_8,Gallery_image_9,Gallery_image_10,
  Gallery_image_11,Gallery_image_12,Gallery_image_13,Gallery_image_14,Gallery_image_15,Gallery_image_16, Gallery_image_17,Gallery_image_18,Gallery_image_19,Gallery_image_20,
  Gallery_image_21,Gallery_image_22       
  ];

  const [zoomedImage, setZoomedImage] = useState(null);

  const handleZoom = (image) => {
    if (zoomedImage === image) {
      setZoomedImage(null); 
    } else {
      setZoomedImage(image); 
    }
  };

  const handleBack = () => {
    setZoomedImage(null); 
  };

  return (
    <div className="gallery-main-container">
      <div className={`images-gallery ${zoomedImage ? 'zoomed-gallery' : ''}`}>
        {images.map((image, index) => (
          <div className="image-gallery1" key={index}>
            <img 
              src={image} 
              className={`Gallery_image_1 ${zoomedImage === image ? 'zoomed' : ''}`} 
              alt={`gallery-img-${index}`} 
              onClick={() => handleZoom(image)} 
              style={{ height: '200px', width: '300px' }}
            />
          </div>
        ))}
      </div>

      {zoomedImage && (
        <div className="zoomed-image-container">
          <img
            src={zoomedImage}
            alt="Zoomed Full View"
            className="zoomed-image"
            style={{ height: '500px', width: '800px' }}
          />
          <button className="back-button" onClick={handleBack}>
            Back to Gallery
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
